var render = function render(){var _vm=this,_c=_vm._self._c;return _c('manage',{attrs:{"title":"单位资产","load-parm":_vm.loadParm}})
}
var staticRenderFns = []

export { render, staticRenderFns }